var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.requireVoucher.no))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.requireVoucher.requireComName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.requireVoucher.applicantName))])
        ])
      ]),
      _vm._v(" "),
      _vm.requireVoucher != null && _vm.requireVoucher.itemList != null
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.requireVoucher.itemList[0].desireArriveDate))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-1-5x" },
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择", clearable: true },
                model: {
                  value: _vm.userId,
                  callback: function($$v) {
                    _vm.userId = $$v
                  },
                  expression: "userId"
                }
              },
              _vm._l(_vm.retailerStaffList, function(item) {
                return _c("el-option", {
                  key: item.name,
                  attrs: { label: item.name, value: item.name }
                })
              })
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.requireVoucher.desc))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.getItemList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "requireComName", label: "公司名称", width: "180" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名称", width: "180" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "goodsCatName", label: "商品分类", width: "180" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "goodsBrandName", label: "商品品牌", width: "180" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "申请数量", width: "95" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: scope.row.quantity,
                          callback: function($$v) {
                            _vm.$set(scope.row, "quantity", _vm._n($$v))
                          },
                          expression: "scope.row.quantity"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          staticStyle: {
                            "background-color": "transparent",
                            border: "none"
                          },
                          attrs: { "close-transition": "" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.removeGoods(scope.$index)
                                }
                              }
                            },
                            [_vm._v("移除")]
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("经办人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("期望到货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("指定审核人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("采购需求")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e33f532", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e33f532","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/RequireGoodsItemUpdate.vue
// module id = 2885
// module chunks = 0